export const approvalStatusENUM = {
  APPROVED: "APPROVED",
  IN_ANALYSIS: "IN_ANALYSIS",
  REJECTED: "REJECTED",
   CANCELED: "CANCELED",
};
